module.exports = __webpack_public_path__ + "static/media/caroline-constas-Blue-gabriella-Stripe-Poplin-Off-shoulder-Bustier-Top_thumb.4e40d3fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/some-extra- womenswear- product-shots/thumbs/caroline-constas-Blue-gabriella-Stripe-Poplin-Off-shoulder-Bustier-Top_thumb.png
// module id = 326
// module chunks = 0